// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storyAttachment__dVVwpO67NQ{width:100%;height:100%;overflow:hidden}`, "",{"version":3,"sources":["webpack://./src/components/conversation/conversationEventGroups/components/groups/instagramStoryEventGroup/conversationInstagramStoryEventGroup.module.scss"],"names":[],"mappings":"AAEA,6BACE,UAAA,CACA,WAAA,CACA,eAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/dist/scss';\n\n.storyAttachment {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storyAttachment": `storyAttachment__dVVwpO67NQ`
};
export default ___CSS_LOADER_EXPORT___;
